import { Dialog, useDialog } from 'components';
import { FC, useEffect, useState } from 'react';
import { getLocations, resendLiftOffEdi, resendLiftOnEdi, resendStatusEdi } from 'services';
import { ActiveUnit, EdiCustomerLocation, Location } from 'types';
import './unit-details.scss';

export const ResendUnitEdiDialog: FC<{
  close: () => void;
  ediCustomerLocations: EdiCustomerLocation[];
  unit: ActiveUnit;
}> = ({ close, ediCustomerLocations, unit }) => {
  const [_locations, setLocations] = useState<Location[]>([]);
  const { openDialog, ref } = useDialog();
  useEffect(() => {
    openDialog();
    getLocations().then(setLocations);
  }, [setLocations]);

  const [recipients, setRecipients] = useState<EdiCustomerLocation[]>([]);

  return (
    <Dialog closeDialog={close} ref={ref}>
      <h3 className="page-header text-primary-dark header-border-bottom">EDI Recipients</h3>
      <div>
        {ediCustomerLocations.some(r => r.ediType === 'STATUS') && <>
          <h4 className='blue-header'>Status</h4>
          <div className={`grid-3 p-2 align-items-center light-underline`}>
            <span className="d-flex justify-content-center margin-bottom-16px">Mapping ID</span>
            <span className="d-flex justify-content-center margin-bottom-16px">Partnership ID</span>
            <span className="d-flex justify-content-center margin-bottom-16px">Resend</span>
            {ediCustomerLocations.filter(r => r.ediType === 'STATUS').map((row, idx) => (
              <>
                <div className={`grid-row-${idx + 2} d-flex justify-content-center `}>{row.mappingId}</div>
                <div className={`grid-row-${idx + 2} d-flex justify-content-center `}>{row.partnershipId}</div>
                <input
                  key={idx + '7'}
                  className={`grid-column-3 grid-row-${idx + 2} padding-bottom-0px`}
                  checked={recipients.map(r => r.id).includes(row.id)}
                  type="checkbox"
                  onChange={e => {
                    const index = recipients.map(r => r.id).findIndex(n => n === row.id);
                    index < 0
                      ? setRecipients([...recipients, row])
                      : setRecipients([...recipients.slice(0, index), ...recipients.slice(index + 1)]);
                  }}
                />
              </>
            ))}
          </div>
        </>}
        {ediCustomerLocations.some(r => r.ediType === 'LIFT') && <>
          <h4 className='blue-header'>Lift</h4>
          <div className={`grid-3 p-2 align-items-center light-underline`}>
            <span className="d-flex justify-content-center margin-bottom-16px">Mapping ID</span>
            <span className="d-flex justify-content-center margin-bottom-16px">Partnership ID</span>
            <span className="d-flex justify-content-center margin-bottom-16px">Resend</span>
            {ediCustomerLocations.filter(r => r.ediType === 'LIFT').map((row, idx) => (
              <>
                <div className={`grid-row-${idx + 2} d-flex justify-content-center `}>{row.mappingId}</div>
                <div className={`grid-row-${idx + 2} d-flex justify-content-center `}>{row.partnershipId}</div>
                <input
                  key={idx + '7'}
                  className={`grid-column-3 grid-row-${idx + 2} padding-bottom-0px`}
                  checked={recipients.map(r => r.id).includes(row.id)}
                  type="checkbox"
                  onChange={e => {
                    const index = recipients.map(r => r.id).findIndex(n => n === row.id);
                    index < 0
                      ? setRecipients([...recipients, row])
                      : setRecipients([...recipients.slice(0, index), ...recipients.slice(index + 1)]);
                  }}
                />
              </>
            ))}
          </div>
        </>}
        <div className="d-flex flex-row justify-content-end g-2 margin-top-16px">
          <button className="btn-outline" onClick={close}>
            Cancel
          </button>
          <button
            className="btn-primary"
            onClick={e => {
              recipients
                .filter(r => r.ediType === 'LIFT' && !!r.id)
                .forEach(r => {
                  resendLiftOnEdi(unit.id, r.id as any);
                  resendLiftOffEdi(unit.id, r.id as any)
                });
              recipients
                .filter(r => r.ediType === 'STATUS' && !!r.id)
                .forEach(r => resendStatusEdi(unit.id, r.id as any));
              close();
            }}
          >
            Send
          </button>
        </div>
      </div>
    </Dialog>
  );
};
